/************** Newsletter section *******************/
const agree = document.getElementById("agree");
if (agree) {
  agree.addEventListener("change", function () {
    if (this.checked) {
      this.nextElementSibling.style.display = "none";
    }
  });
}

const newsletterSubmitBtn = document.getElementById("newsletter__submit_btn");
if (newsletterSubmitBtn) {
  newsletterSubmitBtn.addEventListener("click", function (event) {
    const agreeCheckbox = document.getElementById("agree");
    if (agreeCheckbox.checked) {
      agreeCheckbox.classList.remove("not-selected");
      agreeCheckbox.nextElementSibling.style.display = "none";
      this.submit();
    } else {
      agreeCheckbox.classList.add("not-selected");
      setTimeout(() => {
        agreeCheckbox.nextElementSibling.style.display = "block";
      }, 100);
      event.preventDefault();
    }
  });
}

/************** Footer Newsletter *******************/
const agreeCk = document.getElementById("agree_ck");
if (agreeCk) {
  agreeCk.addEventListener("change", function () {
    if (this.checked) {
      this.nextElementSibling.style.display = "none";
    }
  });
}

const newsletterFooterSubmitBtn = document.getElementById("newsletter_fotter__submit_btn");
if (newsletterFooterSubmitBtn) {
  newsletterFooterSubmitBtn.addEventListener("click", function (event) {
    const agreeCheckbox = document.getElementById("agree_ck");
    if (agreeCheckbox.checked) {
      agreeCheckbox.classList.remove("not-selected");
      agreeCheckbox.nextElementSibling.style.display = "none";
      this.submit();
    } else {
      agreeCheckbox.classList.add("not-selected");
      setTimeout(() => {
        agreeCheckbox.nextElementSibling.style.display = "block";
      }, 100);
      event.preventDefault();
    }
  });
}

/************** Cart Page *******************/

window.addEventListener('load',() => {
  setTimeout(() => {
    const cartCheckboxes = document.querySelectorAll(".cart-required--checkbox");
    if (cartCheckboxes.length > 0) {
      cartCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("click", function () {
          if (this.checked) {
            this.nextElementSibling.style.display = "none";
          }
        });
      });
    }
    const cartSubmitBtn = document.getElementById("cart__submit_btn");
    console.log("cartSubmitBtn ::; ",cartSubmitBtn)
    if (cartSubmitBtn) {
      cartSubmitBtn.addEventListener("click", function (event) {
        const checkboxes = document.querySelectorAll(".cart-required--checkbox");
        let allChecked = true;
    
        checkboxes.forEach((checkbox) => {
          if (!checkbox.checked) {
            allChecked = false;
            checkbox.nextElementSibling.style.display = "block";
          } else {
            checkbox.classList.remove("not-selected");
            checkbox.nextElementSibling.style.display = "none";
          }
        });
    
        if (!allChecked) {
          event.preventDefault();
        } else {
          this.classList.add("btn--loading");
          this.submit();
        }
      });
    }
  }, 2000);
});

/************** Side Cart Page *******************/
  /**
   * Side cart Event added in theme.js file
   * Line no: 4953
   */

/************** Contact Page *******************/
const contactAgree = document.getElementById("contact_agree");
if (contactAgree) {
  contactAgree.addEventListener("change", function () {
    if (this.checked) {
      this.nextElementSibling.style.display = "none";
    }
  });
}

const contactSubmitBtn = document.getElementById("contact__submit_btn");
if (contactSubmitBtn) {
  contactSubmitBtn.addEventListener("click", function (event) {
    const contactAgree = document.getElementById("contact_agree");
    if (contactAgree.checked) {
      contactAgree.classList.remove("not-selected");
      contactAgree.nextElementSibling.style.display = "none";
      this.submit();
    } else {
      contactAgree.classList.add("not-selected");
      setTimeout(() => {
        contactAgree.nextElementSibling.style.display = "block";
      }, 100);
      event.preventDefault();
    }
  });
}

/************** Register Page *******************/
const registerAgree = document.getElementById("register_agree");
if (registerAgree) {
  registerAgree.addEventListener("change", function () {
    if (this.checked) {
      this.nextElementSibling.style.display = "none";
    }
  });
}